import { Location } from '@angular/common';
import { AbstractControl, NgForm } from '@angular/forms';
import { BaseBusyableComponent } from './BaseBusyableComponent';

declare var tinyMCEConfig: any;

export abstract class BaseEditComponent extends BaseBusyableComponent {

	constructor() {
		super();
		this.editorConfig = tinyMCEConfig;
	}

	public editorConfig: any = {};

	validationErrors: string[] = [];

	showValidationErrors(error: any, form: NgForm) {
		var errors = this.getErrorsFromResponse(error);
		this.validationErrors = errors;
		if (error.error) {
			error = error.error;
		}
		if (error.errors) {
			error = error.errors;
		}
		if (form) {
			if (error) {
				for (var key in error) {
					if (error.hasOwnProperty(key)) {
						var fieldName = key.substring(key.indexOf("."));
						if (fieldName) {
							for (var itemControlName in form.controls) {
								if (itemControlName.endsWith(fieldName)) {
									var elem = form.controls[itemControlName];
									if (elem) {
										elem.markAsTouched();
										elem.setErrors({ 'custom': error[key][0] });
									}
								}
							}
						}
					}
				}
			};
		}
		this.isSaving = false;
	}
	cancelAfterSave(form: NgForm) {
		this.cancel(form);
	}
	cancel(form: NgForm) {
		this.isSaving = false;
		this.validationErrors = [];
		if (form) {
			form.reset(form.value);
		}
		this.goBack();
	}

	setLiveCSS(elem: AbstractControl, property: string) {
		elem.setErrors({ property: true });
		//var ctrl = $(property);
		//var setValidity = function () {
		//	elem.setErrors({ property: false });
		//	ctrl.off('blur', setValidity);
		//}

		//// check validity on field blur
		//var blurVariable = ctrl.on('blur', setValidity);

		//// set "valid" by default on typing
		//var keyupVariable = ctrl.bind('keyup', setValidity);
	}
}


